// extracted by mini-css-extract-plugin
export default {"musicWrapper":"MusicControl_musicWrapper__28SF0","musicControl":"MusicControl_musicControl__jMvV6","control":"MusicControl_control__zCrsS"};